export default {
  systemCompanies: {
    companies: [],
    total: 0,
  },
  myUsers: {
    users: [],
    total: 0,
  },
  allCompanies: [],
  loading: true,
  segments: [],
};



// WEBPACK FOOTER //
// ./src/store/modules/master/initialState.js